export const HEADER_HEIGHT_FULL = '100px';
export const HEADER_HEIGHT = '80px';
